import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { CommonConfig } from "../../CommonConfig.js";
import api from "../../utils/api";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.js";

const initialTemplate = {
  name: "",
  nameErr: false,
  nameErrText: "",
  description: "",
};

const TemplateMaster = (props) => {
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null },
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const [templateId, setTemplateId] = useState(null);
  const [templateList, setTemplateList] = useState([]);
  const [isDeleteMaster, setIsDeleteMaster] = useState(false);
  const [isAddMaster, setIsAddMaster] = useState(false);
  const [isViewMaster, setIsViewMaster] = useState(false);
  const [template, setTemplate] = useState(initialTemplate);

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <>
        <div className="p-d-flex p-ai-center">
          <Button
            className="e-add-btn"
            onClick={() => handleOpen(rowData, "EditMaster")}
            tooltip={"Edit"}
            tooltipOptions={{ className: "bluegray-tooltip", position: "top" }}
          >
            <i className="icon-editImage"></i>
          </Button>

          <Button
            className="e-add-btn"
            onClick={() => handleOpen(rowData, "DeleteMaster")}
            tooltip={"Delete"}
            tooltipOptions={{ className: "bluegray-tooltip", position: "top" }}
          >
            <i className="icon-delete"></i>
          </Button>
        </div>
      </>
    );
  };

  useEffect(() => {
    let token = localStorage.getItem("Token");
    let data = localStorage.getItem("Infodata");
    if (token !== null) {
      setUserId(data);
      GetTemplate(data);
    } else {
      props.history.push("/login");
    }
    return () => {};
  }, []);

  const GetTemplate = async (UserId) => {
    try {
      setLoading(true);
      let data = {
        UserId,
      };
      await api
        .post(APIConstant.path.GetTemplate, data)
        .then(async (res) => {
          let response = await res;
          if (response.Success === 1) {
            setTemplateList(response.Data);
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log({ err });
        });
    } catch (err) {
      setLoading(false);
      console.log({ err });
    }
  };

  const handleChange = (value, field, regex) => {
    if (!value) {
      setTemplate((prev) => ({
        ...prev,
        [field]: value,
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        setTemplate((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
        }));
      }
    }
  };

  const validation = () => {
    let formIsValid = true;
    if (CommonConfig.isEmpty(template.name)) {
      formIsValid = false;
      setTemplate((prevState) => ({
        ...prevState,
        nameErr: true,
        nameErrText: "Name is required",
      }));
    }

    return formIsValid;
  };

  const handleOpen = async (item, type) => {
    console.log({ item });
    if (type === "AddMaster") {
      setIsAddMaster(true);
    } else if (type === "EditMaster") {
      setIsAddMaster(true);
      setTemplateId(item.TemplateId);
      setTemplate({
        name: item.TemplateName,
        nameErr: false,
        nameErrText: "",
        description: item.Description,
      });
    } else if (type === "DeleteMaster") {
      setTemplateId(item.TemplateId);
      setIsDeleteMaster(true);
    } else if (type === "ViewMaster") {
      setIsViewMaster(true);
      setTemplateId(item.TemplateId);
      setTemplate({
        name: item.TemplateName,
        nameErr: false,
        nameErrText: "",
        description: item.Description,
      });
    }
  };

  const handleClose = async (type) => {
    setTemplate(initialTemplate);
    if (type === "AddMaster") {
      setIsAddMaster(false);
    } else if (type === "EditMaster") {
      setIsAddMaster(false);
    } else if (type === "DeleteMaster") {
      setTemplateList(null);
      setIsDeleteMaster(false);
    } else if (type === "ViewMaster") {
      setIsViewMaster(false);
    }
  };

  const handleAddMaster = async (e) => {
    e.preventDefault();
    if (validation()) {
      setLoading(true);
      let data = {
        TemplateId: templateId,
        UserId: userId,
        TemplateName: template.name,
        Description: template.description,
      };
      try {
        api
          .post(APIConstant.path.AddUpdateTemplate, data)
          .then(async (res) => {
            const response = await res;
            if (response.Success === 1) {
              setLoading(false);
              cogoToast.success(response.Message);
              handleClose("AddMaster");
              await GetTemplate(userId);
            } else {
              setLoading(false);
              cogoToast.error(response.Message);
            }
          })
          .catch((err) => {
            setLoading(false);
            cogoToast.error(err);
          });
      } catch (err) {
        setLoading(false);
        cogoToast.error(err);
      }
    }
  };

  const handleDeleteMaster = async (Id) => {
    try {
      setLoading(true);
      let data = {
        UserId: userId,
        TemplateId: templateId,
      };
      await api
        .post(APIConstant.path.DeleteTemplate, data)
        .then(async (res) => {
          let response = await res;
          if (response.Success === 1) {
            await GetTemplate(userId);
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          cogoToast.error(err);
        });
    } catch (err) {
      setLoading(false);
      cogoToast.error(err);
    }
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between p-pr-2 p-pl-3">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-filter-slash"></i>
          <h2>Template Master</h2>
        </div>
        <div className="p-ml-auto p-d-lg-flex p-ai-center">
          <span className="searchbar-area">
            <InputText
              type="search"
              onChange={onGlobalFilterChange}
              placeholder="Global Search"
              size="30"
            />
            <i className="icon-search"></i>
          </span>
        </div>
        <div className="card-actions">
          <Button
            type="button"
            className="e-add-btn"
            onClick={(e) => handleOpen(e, "AddMaster")}
          >
            <i className="icon-add"></i>
          </Button>
        </div>
      </div>
      <hr />
      <div className="custom-large-wb-table e-common-master-table">
        <DataTable
          filters={filters}
          className="main-table table-td"
          value={templateList}
          editMode="row"
          dataKey="id"
          responsiveLayout="scroll"
          paginator={true}
          rows={10}
          totalRecords={templateList.length}
          rowsPerPageOptions={CommonConfig.dataTableConfig.rowsPerPageOptions}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "5%" }}
          ></Column>
          <Column
            field="TemplateName"
            header="Template Name"
            style={{ width: "10%" }}
          ></Column>

          <Column
            field="Action"
            header="Action"
            body={actionBodyTemplate}
            headerStyle={{ width: "8%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        </DataTable>
      </div>

      {/* Delete Confirm Modal */}
      <Dialog
        open={isDeleteMaster}
        className="stock-modal"
        onClose={(e) => handleClose("DeleteMaster")}
        fullWidth
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Template</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("DeleteMaster")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent>
          <span>Are you sure want to delete this template ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("DeleteMaster")}
          >
            Cancel
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => handleDeleteMaster(templateId)}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isAddMaster}
        className="stock-modal"
        onClose={(e) => handleClose("AddMaster")}
        fullWidth
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>{templateId ? "Edit Template" : "Add Template"}</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("AddMaster")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent>
          <>
            <GridItem md={12}>
              <label>Name</label>
              <InputText
                placeholder="Name"
                id="name"
                className="p-w-100 p-mt-1"
                type="text"
                value={template.name}
                maxLength={20}
                disabled={isViewMaster}
                onChange={(e) => handleChange(e.target.value, "name")}
              />
              <span className="error-msg" style={{ color: "red" }}>
                {template.nameErr ? template.nameErrText : null}{" "}
              </span>
            </GridItem>
            <GridItem md={12}>
              <div className="p-mt-3">
                <label>Description</label>
                <InputText
                  rows={4}
                  placeholder="description"
                  id="description"
                  className="p-w-100 p-mt-1"
                  type="text"
                  value={template.description}
                  maxLength={300}
                  disabled={isViewMaster}
                  onChange={(e) => handleChange(e.target.value, "description")}
                />
              </div>
            </GridItem>
          </>
        </DialogContent>
        <DialogActions>
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("AddMaster")}
          >
            Cancel
          </Button>
          <Button className="primary-btn" onClick={(e) => handleAddMaster(e)}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TemplateMaster;
